<template>
  <CalibrationHost />
</template>
<script>
import CalibrationHost from '@/components/dashboard/CalibrationHost.vue'
export default {
  name: 'CalibrationView',
  components: {
    CalibrationHost
  }
}
</script>
<style lang="scss" scoped></style>
